import React from "react";
import Files from "react-files";
import { Button } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getAuthTokenAndAddUserList } from "../../../../redux/actions/users";

const generator = require("generate-password");

const XLSX = require("xlsx");

class Sheet extends React.Component {
  onFilesChange = files => {
    const reader = new FileReader();

    reader.onload = evt => {
      const arr = [];
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      const data = XLSX.utils.sheet_to_json(ws, { raw: true });

      data.map(row => {
        const userRow = Object.values(row);
        if (userRow.length > 3) {
          const userPassword = generator.generate({
            length: 8
          });
          const user = {
            password: userPassword,
            rut: userRow[1] || "",
            nombre: userRow[2] || "",
            nivel: userRow[3] || "",
            identificadorNivel: userRow[4] || "",
            colegio: userRow[5] || ""
          };
          this.props.getAuthTokenAndAddUserList(user);
        }
      });
      this.props.onChange(arr, data[0]);
    };

    reader.readAsBinaryString(files[0]);
  };

  render() {
    return (
      <React.Fragment>
        <Files onChange={this.onFilesChange} multiple minFileSize={0} clickable>
          <Button type="primary">Subir Listas de alumnos</Button>
        </Files>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getAuthTokenAndAddUserList }, dispatch);
};

export default connect(
  null,
  mapDispatchToProps
)(Sheet);
